module.exports = __webpack_public_path__ + "img/puzzle_22.6024d8f9.png";